import { render } from "./ApprovalModal.vue?vue&type=template&id=6b4afe76&scoped=true"
import script from "./ApprovalModal.vue?vue&type=script&lang=js"
export * from "./ApprovalModal.vue?vue&type=script&lang=js"

import "./ApprovalModal.vue?vue&type=style&index=0&id=6b4afe76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4afe76"]])

export default __exports__